import type { ReactNode } from "react";
import { type SubscriptionPlan, useSubscription } from "~/lib/hooks/use-subscription";
import { PaywallOverlay } from "./paywall-overlay";

const PLAN_HIERARCHY: Record<SubscriptionPlan, number> = {
	FREE: 0,
	PREMIUM: 1,
	PRO: 2,
	ENTERPRISE: 3,
};

interface FeatureGateProps {
	minPlan: SubscriptionPlan;
	fallback?: ReactNode;
	children: ReactNode;
}

export function FeatureGate({ minPlan, fallback, children }: FeatureGateProps) {
	const { effectivePlan, loading } = useSubscription();

	if (loading) return null;

	const hasAccess = PLAN_HIERARCHY[effectivePlan] >= PLAN_HIERARCHY[minPlan];

	if (hasAccess) {
		return <>{children}</>;
	}

	if (fallback) {
		return <>{fallback}</>;
	}

	return <PaywallOverlay requiredPlan={minPlan}>{children}</PaywallOverlay>;
}
